import React from 'react'
import Header from '../Header/Header'

export default function PermanentITStaffing() {
  return (
      <>
      <Header isActive={"Services"}/>
    <div id="content" class="site-content">
        <div className="page-header dtable text-center" style={{ backgroundImage: 'url(resources/images/banner-.jpg)' }}>
   <div className="dcell">
      <div className="container">
         <h1 className="page-title">Permanent IT Staffing</h1>
      </div>
   </div>
</div>
<section className="p-b0">
   <div className="container">
      <div className="flex-row">
         <div className="services-left-1">
            <img src="resources/images/img-services-2.png" alt="" />
         </div>
         <div className="services-right-1 align-self-center">
            <div className="ot-heading">
               <h6><span>Permanent IT Staffing</span></h6>
               <h2 className="main-heading">Empower Your Workforce with Humanix Technologies</h2>
            </div>
            <p className="m-b50">
            At Humanix Technologies, we offer IT consulting services focused on permanent staffing solutions to enhance your software architecture, craft a technology-driven digital strategy, and optimize your software portfolio. Our expert software engineers will support your digital transformation journey by providing skilled, long-term talent, ensuring seamless integration from strategic planning to execution.</p>
            <div className="row">
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="100" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Active Developers</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40 xs-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="30" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Satisfied Clients</h6>
                  </div>
               </div>
               <div className="col-md-4 col-sm-6 col-xs-6 xs-text-center sm-m-b40">
                  <div className="ot-counter s3">
                     <div>
                        <span className="num" data-to="50" data-time="2000">0</span>
                        <span>+</span>
                     </div>
                     <h6>Innovative Solutions Delivered</h6>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t110 p-b70">
   <div className="container">
      <div className="row">
        <h1>What You Will Gain</h1>
         <div className="col-md-6 col-sm-12 col-xs-12 sm-m-b40">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">01</span>
               <div className="number-box">01</div>
               <div className="content-box">
                  <h5>Skilled Developers On-Demand</h5>
                  <p>Access a pool of highly skilled developers proficient in cutting-edge technologies to meet your business requirements.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">02</span>
               <div className="number-box">02</div>
               <div className="content-box">
                  <h5>Tailored Development Solutions</h5>
                  <p>Get developers with expertise in creating custom applications, scalable software, and business-driven IT solutions.</p>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-sm-12 col-xs-12">
            <div className="service-box s-box m-b30">
               <div className="overlay"></div>
               <span className="big-number">03</span>
               <div className="number-box">03</div>
               <div className="content-box">
                  <h5>Seamless Team Integration</h5>
                  <p>Hire developers who can integrate seamlessly with your in-house teams, ensuring smooth collaboration and productivity.</p>
               </div>
            </div>
            <div className="service-box s-box">
               <div className="overlay"></div>
               <span className="big-number">04</span>
               <div className="number-box">04</div>
               <div className="content-box">
                  <h5>Scalable Workforce</h5>
                  <p>Quickly scale your development team to adapt to project needs, ensuring timely delivery and flexibility for your business.</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>
{/* <section className="p-t100 p-b50">
   <div className="container">
      <div className="row">
         <h1>Curriculum</h1>
         <div className="col-md-6 col-xs-12 sm-m-b40">
            <div className="ot-accordions">
               <div className="acc-item current">
                  <span className="acc-toggle">Level -1<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content active" style={{ display: 'block' }}>
                     <h6>Programming Fundamentals</h6>
                     <div className="row">
                        <div className="col-xs-4">6 Weeks</div>
                        <div className="col-xs-4">1 Guest Lecture</div>
                        <div className="col-xs-4">2 Contests</div>
                     </div>
                     This module will help beginners to get familiar with programming
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -2 <i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Building an E-Commerce Website</h6>
                     <div className="row">
                        <div className="col-xs-6">6 Weeks</div>
                        <div className="col-xs-6">1 Guest Lecture</div>
                     </div>
                     <p>Understand the core fundamentals of site building from industry experts and build an E-commerce website. Learning is meaningful when you can apply the concepts and solve real-world problems. We will explore this possibility in this module.</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -3<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Data Structures and Algorithms</h6>
                     <div className="row">
                        <div className="col-xs-6">6 Weeks</div>
                        <div className="col-xs-6">1 Guest Lecture</div>
                     </div>
                     <p>Now that we have a fair idea about HTML, CSS and React, let's enhance our problem-solving skills further by learning the intermediate and advanced concepts of Data Structures and Algorithms. In this module, we will extensively focus on problem-solving.</p>
                  </div>
               </div>
            </div>
         </div>
         <div className="col-md-6 col-xs-12">
            <div className="ot-accordions accordions-gradient">
               <div className="acc-item current">
                  <span className="acc-toggle">Level -4<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content active" style={{ display: 'block' }}>
                     <h6>Building a CRM App</h6>
                     <div className="row">
                        <div className="col-xs-6">5 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Build the frontend to run a CRM app that will help you manage all your business leads at one place and provide a complete picture of all customer interactions...</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -5<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Building a Movie Booking App</h6>
                     <div className="row">
                        <div className="col-xs-6">4 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Build a website in which users can book a movie, a match, or any event of their choice at a location and price suitable for them.</p>
                  </div>
               </div>
               <div className="acc-item">
                  <span className="acc-toggle">Level -6<i className="down flaticon-arrow-pointing-to-down"></i><i className="up flaticon-arrow-pointing-to-up"></i></span>
                  <div className="acc-content">
                     <h6>Interview Practice</h6>
                     <div className="row">
                        <div className="col-xs-6">4 Weeks</div>
                        <div className="col-xs-6">1 Contest</div>
                     </div>
                     <p>Solve sample test questions and get ready to ace the interviews.</p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

<section className="p-t120 p-b50 bg-pricing">
   <div className="container">
      <div className="ot-heading text-center">
         <h2 className="main-heading">Pricing Details</h2>
      </div>
      <div className="row">
         <div className="col-md-4 sm-p-b60"></div>
         <div className="col-md-4 sm-p-b60">
            <div className="ot-pricing-table bg-shape s2">
               <span className="title-table">10% Discount</span>
               <div className="inner-table sm-p-t60">
                  <img src="resources/images/price2-1.png" alt="Economy" />
                  <h6><s><sup>₹</sup> 75000</s></h6>
                  <h2><sup>₹</sup> 67500</h2>
                  <p></p>
                  <div className="details">
                     <ul>
                        <li>Course Duration 6 Months</li>
                        <li>40L Highest salary offered</li>
                        <li>8.4L Average CTC offered</li>
                        <li>9 Days Placement time</li>
                        <li>Upto 350% Salary hike</li>
                     </ul>
                  </div>
               </div>
               <a href="contact.html" className="octf-btn octf-btn-icon octf-btn-third">ENROLL NOW <i className="flaticon-right-arrow-1"></i></a>
            </div>
         </div>
         <div className="col-md-4"></div>
      </div>
   </div>
</section> */}
<section className="container">
   <div className="p-t120">
      <div className="row flex-row align-items-end">
         <div className="col-lg-6 col-md-12 col-xs-12 xs-m-b40">
            <div className="ot-heading">
               <h2 className="main-heading">Here to Help Your Every Business Need</h2>
            </div>
            <div className="ot-accordions">
               <div className="acc-item current">
                  <div className="acc-content active" style={{ display: 'block' }}>We specialize in providing permanent staffing solutions, allowing you to focus on growing your business.
Let us take care of your staffing needs while you concentrate on what matters most.
Explore how our skilled developers can seamlessly integrate into your team and drive success.
Partner with us to unlock the full potential of your business through expert, long-term staffing solutions.
We’re here to provide the talent you need, ensuring your business thrives with skilled professionals.
Discover how our permanent staffing solutions can enhance your team—start today!</div>
               </div>
            </div>
         </div>
         <div className="col-lg-6 col-md-12 col-xs-12 text-center">
            <img src="resources/images/img.png" alt="seo" />
         </div>
      </div>
   </div>
</section>

{/* <section className="p-b50">
   <div className="container">
      <div className="row">
         <div className="col-md-12">
            <div className="partners">
               <div className="owl-carousel home-client-carousel">
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-4.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-10.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-8.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-6.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/zoomcar-17.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/cred.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/meeso.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/paytm.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/upgrad.webp" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/rakuten.png" alt="" />
                        </figure>
                     </a>
                  </div>
                  <div className="partners-slide">
                     <a href="#" className="client-logo">
                        <figure className="partners-slide-inner">
                           <img className="partners-slide-image" src="resources/images/brands/delhiberry.webp" alt="" />
                        </figure>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section> */}
    </div>
    </>
  )
}
